/* eslint-disable */
import React from 'react';
import Copyright from './Copyright';
import '~styles/modules/credits.scss';

const Credits = ({ data }) => {
  // create columns of <li> elements for the credits well
  const list = data.credits.map((credit) => {
    const listKey = `${credit.role}-${credit.name}`;
    return (
      <li className="bentonsanscond-n4" key={listKey}>
        <span className="bentonsanscond-n6">
          {credit.role}
          {': '}
        </span>
        {credit.name}
      </li>
    );
  });

  return (
    <div id="credit__well">
      <div id="credits" className="text__well">
        <h6 className="bentonsanscond-n6">Credits</h6>
        <div className="credits__wrapper">
          <ul className="credit-list">
            {list}
            <li className="bentonsanscond-n4" key="Quality Assurance-Nalini Dokula">
              <span className="bentonsanscond-n6">Contributor:</span> Sam Trottenberg, Brooke Hauser
            </li>
            <li className="bentonsanscond-n4" key="Copy editors-Paul Colton, James Matte, and Bill Herzog">
              <span className="bentonsanscond-n6">Copy editors:</span> Paul Colton, James Matte, and Bill Herzog
            </li>
            <li className="bentonsanscond-n4" key="Quality Assurance-Nalini Dokula">
              <span className="bentonsanscond-n6">Quality Assurance:</span> Nalini Dokula
            </li>
          </ul>
        </div>
        <Copyright />
      </div>
    </div>
  );
};

export default Credits;
